var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-sessions",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2912",
    "data-name": "Group 2912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    fill: "#f9dddd",
    stroke: "#ed9898",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M8.517,17.437a7.347,7.347,0,1,1,7.346,7.346A7.355,7.355,0,0,1,8.517,17.437Zm1.29,0a6.057,6.057,0,1,0,6.056-6.059A6.063,6.063,0,0,0,9.807,17.437Zm-.225,7.346H.984a.915.915,0,0,1-.86-.406A1.176,1.176,0,0,1,0,23.784L.04.965A.754.754,0,0,1,.182.32.9.9,0,0,1,.851,0H15.59a.663.663,0,0,1,.464.181l4.3,4.2a.647.647,0,0,1,.208.49v4.3a.671.671,0,1,1-1.341-.024v-4L15.311,1.338H1.4V23.443H9.582a.687.687,0,0,1,.669.669.672.672,0,0,1-.588.667l0,0Zm5.043-3.774a.661.661,0,0,1-.466-.2l-2.465-2.535a.65.65,0,1,1,.932-.905L14.6,19.406l4.405-4.945a.649.649,0,1,1,.97.863l-4.866,5.468a.662.662,0,0,1-.473.218ZM4.016,14.668a.744.744,0,0,1,0-1.488H7.651a.746.746,0,0,1,.746.743.769.769,0,0,1-.77.745ZM4.042,11.5a.744.744,0,1,1,0-1.488H9.854a.744.744,0,0,1,0,1.488Zm-.05-3.067a.744.744,0,0,1,0-1.488h9.916a.744.744,0,0,1,0,1.488Zm.05-2.991a.744.744,0,1,1,0-1.488h9.917a.744.744,0,0,1,0,1.488Z",
    transform: "translate(17.391 15.609)",
    fill: "#bc5e5e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.1d13f0b404d5d45f3fb61634831470f5.svg";
export { ForwardRef as ReactComponent };